module.exports = __webpack_public_path__ + "static/media/critical-pin.aceeebfe.svg";